import React, { useState } from "react";

interface ImageWithFallbackProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallbackSrc?: string;
}

export const PLACEHOLDER_IMAGE = "/placeholder.webp";

export const Image: React.FC<ImageWithFallbackProps> = ({ src, fallbackSrc = PLACEHOLDER_IMAGE, alt, ...props }) => {
  const [imgSrc, setImgSrc] = useState(src);

  return <img src={imgSrc} alt={alt} onError={() => setImgSrc(fallbackSrc)} {...props} />;
};
